import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_PARENT_TRIALS_LOAD,
    ACTION_PARENT_TRIALS_LOAD_FAILURE,
    ACTION_PARENT_TRIALS_LOAD_SUCCESS,
    ACTION_PARENT_TRIALS_CLEAR,
    ParentTrialsAction
} from '../actions/parentTrials';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState } from "./index";

export interface IParentTrialsState {
    data: Dtos.Trial[];
    loadState: IRequestState;

}

const initialState: IParentTrialsState = {
    data: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState
};


function loading(state: IParentTrialsState, _isLoading: boolean): IParentTrialsState {
    const newState: IParentTrialsState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IParentTrialsState, data: Dtos.Trial[]): IParentTrialsState {
    const newState: IParentTrialsState = update(state, {
        data: {
            $set: data
        },
        loadState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function loadFailure(state: IParentTrialsState, responseStatus: Dtos.ResponseStatus): IParentTrialsState {
    const newState: IParentTrialsState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(_state: IParentTrialsState): IParentTrialsState {
    const newState: IParentTrialsState = update(initialState, {});

    return newState;
}

const UserReducer: Reducer<IParentTrialsState> = (state: IParentTrialsState = initialState, action: ParentTrialsAction) => {
    switch (action.type) {
        case ACTION_PARENT_TRIALS_LOAD:
            return loading(state, true);
        case ACTION_PARENT_TRIALS_LOAD_SUCCESS:
            return loadSuccess(state, action.data);
        case ACTION_PARENT_TRIALS_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_PARENT_TRIALS_CLEAR:
            return clear(state);
    }

    return state;
}

export default UserReducer;